<template lang="pug">
.row.align-items-center
  .col-12
    .meta-not-installed(v-if='notInstalled')
      img(src='../../assets/metamask/sprite-seed.svg')
      h5 Want more Sprites?
      p You need a safe place to keep them from floating away. A secure digital wallet like MetaMask will do the job. We’ll walk you through it!
      router-link.green-link(:to="{name: 'MetaMaskPage'}") Learn More
    .meta-locked(v-if='locked')
      img(src='../../assets/metamask/hiding-sprite.svg')
      h5 MetaMask Locked
      p Open MetaMask and follow the instructions to unlock it to bring your owned Sprites out of hiding!
    .meta-not-installed(v-if='wrongNetwork && locked')
      p Please switch to the Rinkeby test network
</template>

<style lang="scss" scoped>
  .meta-not-installed, .meta-locked {
    margin-top: 2rem;
    margin-bottom: 2rem;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #a1a39e;
    line-height: 1.43;
    font-size: 14px;

    img {
      margin-bottom: 1em;
    }

    h5 {
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: center;
      color: #a1a39e;
      line-height: 1.43;
      font-size: 14px;
    }

    p {
      font-size: 12px;
      line-height: 1.33;
      font-weight: normal;
      max-width: 272px;
      margin: 0 auto;
    }

    a.green-link {
      margin-top: 1rem;
      display: block;
      letter-spacing: 1px;
      color: #9bc75a;
      text-transform: uppercase;
    }
  }
</style>

<script>
import metamaskWatcher from '../../mixins/metamaskWatcher';

export default {
  mixins: [metamaskWatcher],
};
</script>



// WEBPACK FOOTER //
// src/components/metamask/MetamaskList.vue